/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */

/**
 * Defines the the supported `DLS` theme identifiers for runtime theme switching.
 */
export enum DLSThemes {
  legacy = 'legacy',
  current = 'current'
}

/**
 * Defines the supported `DLS` theme modes. Dark is a mode of the `current`
 * theme, not a separate theme identifier.
 */
export enum DLSThemeModes {
  light = 'light',
  dark = 'dark'
}

/**
 * Defines the supported numerical font weights for the current DLS theme.
 */
export type DLSFontWeight = 400 | 500 | 600 | 700;

/**
 * Defines the supported numerical font weights for the legacy DLS theme.
 */
export type LegacyDLSFontWeight = DLSFontWeight | 300;
